import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import './AppFooter.css';

class AppFooter extends PureComponent {
  render() {
    return (
      <footer className="app-footer u-fx u-fx-align-center u-fx-justify-center u-fx-column">
        <p>© Stratec SE</p>
        <p>
          Version: {this.props.dashboardVersion || 'Undefined'} |{' '}
          {this.props.webAPIVersion || 'Undefined'}
        </p>
      </footer>
    );
  }
}

AppFooter.propTypes = {
  dashboardVersion: PropTypes.string,
  webAPIVersion: PropTypes.string
};

AppFooter.defaultProps = {
  dashboardVersion: '',
  webAPIVersion: ''
};

export default AppFooter;
